import { Community } from 'redux/types/account';

export const handleRedirect = (community: Community) => {
  let env: 'local' | 'staging' | 'production' = 'local';

  console.log('community.isNewFrontendEnabled', community?.isNewFrontendEnabled);

  if (!community?.isNewFrontendEnabled) {
    return;
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'staging' && !window.origin.includes('localhost')) {
    env = 'staging';
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'production') {
    env = 'production';
  }

  const path = window.location.pathname;
  console.log('Current path:', path);
  console.log(path.includes('admin-panel'), !path.includes('events-settings'));
  console.log('window includes app.babele.co', window.origin.includes('app.babele.co'));

  if (path.includes('admin-panel') && !path.includes('events-settings')) {
    console.log('Redirecting to new frontend admin panel', env, path);
    if (env === 'local') {
      window.location.href = `http://localhost:3001${path}`;
    }

    if (env === 'staging') {
      window.location.href = `https://app-new-stag.babele.co${path}`;
    }

    // We must be careful to only redirect to the new frontend if we can redirect to the same main domain
    // If we are on the main babele.com domain, we redirect to the new frontend on admin.babele.co
    // If we are on a custom domain, we only redirect if there's also a custom DNS configured for the new frontend
    // Otherwise, the auth token will not be valid across different base domains and the user will be logged out
    if (env === 'production') {
      if (community?.customDns?.host) {
        if (window.origin.includes('app.babele.co')) {
          window.location.href = `https://app-new.babele.co${path}`;
        } else {
          if (community?.customDns?.newFrontendHost) {
            window.location.href = `https://${community.customDns.newFrontendHost}${path}`;
          }
        }
      } else {
        console.log('no custom DNS configured for the new frontend, redirecting to app-new.babele.co');
        if (window.origin.includes('app.babele.co')) {
          console.log('Redirecting to app-new.babele.co');
          window.location.href = `https://app-new.babele.co${path}`;
        }
      }
    }
  }
};

export const getNewFrontendHost = (community: Community) => {
  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'production') {
    if (community?.customDns?.newFrontendHost) {
      return `https://${community.customDns.newFrontendHost}`;
    }

    return 'https://app-new.babele.co';
  }

  if (process.env.REACT_APP_DEPLOYMENT_TYPE === 'staging') {
    return 'https://app-new-stag.babele.co';
  }

  return 'http://localhost:3001';
};
